import api from '../api';
import resolveDownloadPath, { resolveDirectFileReference } from './downloads';

export default async function loadCustomFile(file, contentPath, { signal } = {}) {
  if (contentPath) {
    try {
      const response = await api.get(contentPath, { responseType: 'blob', signal });
      return response.data;
    } catch (error) {
      // A stale registry may not resolve a legacy upload. The original route
      // still checks authentication and its own file access permissions.
      if (error?.response?.status !== 404 || signal?.aborted) throw error;
    }
  }
  const direct = resolveDirectFileReference(file);
  if (direct) {
    const response = await fetch(direct, { signal });
    if (!response.ok) throw new Error('Arquivo não disponível.');
    return response.blob();
  }
  const reference = file?.downloadPath || file?.downloadUrl || file?.url || file?.dataUrl || file?.relativePath;
  if (!reference) throw new Error('Arquivo não disponível.');
  const requestPath = reference === file?.relativePath
    ? `/files?path=${encodeURIComponent(reference)}`
    : resolveDownloadPath(reference);
  if (/^[a-z][a-z0-9+.-]*:/i.test(requestPath) || requestPath.startsWith('//')) {
    throw new Error('O endereço do arquivo não pertence ao servidor configurado.');
  }
  const response = await api.get(requestPath, { responseType: 'blob', signal });
  return response.data;
}
